export const DEFAULT_VIEWED_JOBS = []
export const DEFAULT_WIDGET_ENABLED = false
export const DEFAULT_SHOW_WIDGET = false

export default {
  viewedJobs: DEFAULT_VIEWED_JOBS,
  enabled: DEFAULT_WIDGET_ENABLED,
  show: DEFAULT_SHOW_WIDGET
}
